export default __webpack_public_path__ + "static/media/Business-Intelligence-PT.1c0bc3ea.jpg";